import { createFileRoute, Link } from "@tanstack/react-router";
import { StubAdminPage } from "@/components/admin/StubAdminPage";
import { Truck } from "lucide-react";

export const Route = createFileRoute("/admin/fleets")({
  component: () => (
    <StubAdminPage
      icon={Truck}
      title="Fleets"
      subtitle="Manage your fleet groupings"
      action={
        <Link
          to="/admin"
          hash="fleets"
          className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:opacity-90"
        >
          Add fleet
        </Link>
      }
    />
  ),
});
